import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useT } from "@/i18n/I18nProvider";
import { Reveal } from "./Section";

export const TILES = ["tile-sky", "tile-sun", "tile-blue", "tile-peach", "tile-mint", "tile-coral", "tile-sun", "tile-sky"];

export const ServiceCard = ({ s, i = 0, featured = false, className = "" }) => {
  const t = useT();
  const tile = TILES[i % TILES.length];
  const light = tile === "tile-blue" || tile === "tile-coral";
  return (
    <Reveal delay={(i % 4) * 0.06} className={`h-full ${className}`}>
      <Link to={`/services/${s.slug}`} data-testid={`service-card-${s.slug}`} className={`card card-hover group flex flex-col h-full overflow-hidden ${tile}`}>
        {featured && <img src={s.image} alt="" className="w-full h-44 object-cover" />}
        <div className="p-7 flex flex-col flex-1">
          <span className={`w-12 h-12 rounded-md flex items-center justify-center ${light ? "bg-white/20 text-white" : "bg-white text-[var(--blue)]"}`}><s.icon size={24} /></span>
          <h3 className={`mt-5 text-xl font-semibold leading-snug ${light ? "!text-white" : "!text-[var(--ink)]"}`}>{s.title}</h3>
          <p className={`mt-2 text-[15px] leading-relaxed flex-1 ${light ? "text-white/85" : "text-[var(--ink)]/80"}`}>{s.short}</p>
          <span className={`mt-5 inline-flex items-center gap-2 font-semibold text-sm underline underline-offset-4 decoration-2 ${light ? "text-white" : "text-[var(--blue)]"}`}>{t("Find out more")} <ArrowRight size={15} className="group-hover:translate-x-1 transition-transform" /></span>
        </div>
      </Link>
    </Reveal>
  );
};
